module.exports = __webpack_public_path__ + "static/img/Caribbean.e72c23ef.png";